<template>
  <Teleport to="body">
    <TransitionGroup
      name="broadcast"
      tag="div"
      class="fixed inset-0 z-[99999] flex items-center justify-center pointer-events-none"
    >
      <div
        v-for="alert in alerts"
        :key="alert.id"
        class="pointer-events-auto mb-4 w-[460px] max-w-[90vw] rounded-2xl overflow-hidden animate-broadcast-in"
        style="background: linear-gradient(145deg, #13111c 0%, #151525 50%, #13111c 100%); border: 1px solid rgba(99,102,241,0.3); box-shadow: 0 0 60px rgba(99,102,241,0.12), 0 20px 50px rgba(0,0,0,0.4);"
      >
        <div
          class="flex items-center gap-3 px-5 py-3"
          style="background: linear-gradient(135deg, rgba(99,102,241,0.12) 0%, rgba(139,92,246,0.08) 100%); border-bottom: 1px solid rgba(99,102,241,0.15);"
        >
          <div class="size-8 rounded-lg flex items-center justify-center" style="background: linear-gradient(135deg, #6366f1, #8b5cf6);">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
              <path d="M13.73 21a2 2 0 0 1-3.46 0" />
            </svg>
          </div>
          <span class="text-sm font-bold flex-1" style="color: #a5b4fc; letter-spacing: 0.04em;">
            ALERTA DA ADMINISTRAÇÃO
          </span>
          <button
            class="size-7 rounded-lg flex items-center justify-center transition-all hover:bg-white/10"
            style="color: rgba(255,255,255,0.4);"
            @click="dismiss(alert.id)"
          >
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
              <path d="M11 3L3 11M3 3L11 11" />
            </svg>
          </button>
        </div>
        <div class="px-5 py-4">
          <div class="flex items-start gap-3">
            <div class="flex-shrink-0">
              <img
                v-if="alert.sender_avatar && !brokenAvatars.has(alert.sender_avatar)"
                :src="alert.sender_avatar"
                class="size-10 rounded-full object-cover"
                style="border: 2px solid rgba(99,102,241,0.4);"
                @error="onAvatarError(alert.sender_avatar)"
              />
              <div
                v-else
                class="size-10 rounded-full flex items-center justify-center font-bold text-base text-white"
                style="background: linear-gradient(135deg, #6366f1, #8b5cf6);"
              >
                {{ alert.sender_name?.charAt(0)?.toUpperCase() }}
              </div>
            </div>
            <div class="flex-1 min-w-0">
              <p class="text-xs mb-1.5 m-0" style="color: rgba(255,255,255,0.4);">
                Enviado por
                <span class="font-semibold" style="color: rgba(255,255,255,0.85);">{{
                  alert.sender_name
                }}</span>
              </p>
              <p
                class="text-sm leading-relaxed whitespace-pre-wrap m-0 font-medium"
                style="color: rgba(255,255,255,0.9);"
              >
                {{ alert.message }}
              </p>
            </div>
          </div>
        </div>
        <div class="px-5 pb-4 flex justify-end">
          <button
            class="px-5 py-2 rounded-lg text-xs font-bold text-white transition-all hover:brightness-110"
            style="background: linear-gradient(135deg, #6366f1, #8b5cf6);"
            @click="dismiss(alert.id)"
          >
            ✓ Entendido
          </button>
        </div>
      </div>
    </TransitionGroup>
  </Teleport>
</template>

<script setup>
import { ref, reactive, onMounted, onUnmounted } from 'vue';
import { emitter } from 'shared/helpers/mitt';

const alerts = ref([]);
const brokenAvatars = reactive(new Set());
let nextId = 0;

function onAvatarError(url) {
  if (url) brokenAvatars.add(url);
}

function onBroadcast(data) {
  const id = ++nextId;
  alerts.value.push({
    id,
    message: data.message,
    sender_name: data.sender_name,
    sender_avatar: data.sender_avatar,
  });
}

function dismiss(id) {
  alerts.value = alerts.value.filter(a => a.id !== id);
}

onMounted(() => {
  emitter.on('adminBroadcast', onBroadcast);
});

onUnmounted(() => {
  emitter.off('adminBroadcast', onBroadcast);
});
</script>

<style>
@keyframes broadcast-in {
  0% {
    opacity: 0;
    transform: scale(0.85) translateY(-30px);
  }
  60% {
    transform: scale(1.03) translateY(0);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.animate-broadcast-in {
  animation: broadcast-in 0.5s cubic-bezier(0.16, 1, 0.3, 1);
}

.broadcast-enter-active {
  animation: broadcast-in 0.5s cubic-bezier(0.16, 1, 0.3, 1);
}
.broadcast-leave-active {
  transition: all 0.3s ease-in;
}
.broadcast-leave-to {
  opacity: 0;
  transform: scale(0.9) translateY(-10px);
}
</style>
